import FetchInterceptor from "configs/FetchInterceptor";

class OtherDebtServices {
  static async getAll(requestBody) {
    const apiUrl = "/core/v1/purchase/payment/debt-others/get/all";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async add(requestBody) {
    const apiUrl = "/core/v1/purchase/payment/debt-others/add";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getPdf(id) {
    const apiUrl = `/core/v1/purchase/payment/debt-others/get/pdf/${id}`;
    const response = await FetchInterceptor.get(apiUrl, {
      responseType: "blob",
    });
    return response;
  }

  static async getById(id) {
    const apiUrl = `/core/v1/purchase/payment/debt-others/get/${id}`;
    const response = await FetchInterceptor.post(apiUrl);
    return response;
  }
}

export default OtherDebtServices;
